var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8246_1201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73525 12.425L7.68793 20.0441L2.86198 24.1234L1.67824 17.7231L6.73525 12.425Z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3316 12.6208L23.2083 20.2168L27.9423 24.4024L29.2695 18.0301L24.3316 12.6208Z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4881 4.21157C19.8981 1.91497 17.3659 0.519839 15.6668 0.500938C13.9677 0.482037 11.4051 1.82143 9.76438 4.08115L21.4881 4.21157Z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1255 5.288L9.10256 5.14313C8.51602 6.2591 8.16002 7.54065 8.1916 8.95284C8.28567 13.0008 9.62713 20.16 9.62713 20.16L20.2284 20.277L21.2657 20.2894C21.2657 20.2894 22.7674 13.1609 22.9488 9.11701C23.0145 7.70589 22.6871 6.4158 22.1255 5.288ZM15.5159 14.037C13.4778 14.0143 11.8383 12.8772 11.8537 11.4958C11.8691 10.1144 13.5347 9.01404 15.5715 9.0367C17.6084 9.05936 19.2477 10.1965 19.231 11.5779C19.217 12.9594 17.5527 14.0597 15.5159 14.037Z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.332 30.666C29.8154 29.6293 28.3757 28.8734 26.6752 28.8545C26.1309 28.8485 25.6114 28.9178 25.1372 29.0498C24.9885 27.8424 23.5024 26.8818 21.6818 26.8616C21.4184 26.8586 21.1629 26.875 20.9167 26.9098C20.9197 26.8769 20.9201 26.844 20.9204 26.811C20.9306 25.901 19.8501 25.151 18.5076 25.1361C18.1592 25.1322 17.8263 25.178 17.5255 25.2643C16.6953 24.2461 16.48 21.6105 16.48 21.6105L14.2757 21.586C14.2757 21.586 13.9613 24.4739 12.9525 25.4204C12.7208 25.3537 12.4646 25.3161 12.1972 25.3131C11.0721 25.3006 10.1535 25.9084 10.145 26.671C10.1444 26.7287 10.1492 26.7855 10.1594 26.8415C9.83867 26.7674 9.87695 26.7303 9.52038 26.7263C8.09547 26.7104 6.87444 27.3066 6.39754 28.1565C5.87647 28.0033 5.30469 27.9154 4.70367 27.9088C2.52914 27.8846 0.710025 28.9319 0.333854 30.3323L30.332 30.666Z",
    fill: "#3CD856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8246_1201",
    x: 0.33374,
    y: 0.500732,
    width: 31.9983,
    height: 32.1652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8246_1201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8246_1201",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.de869622d3c7cd00aa8a6b67967f7ce8.svg";
export { ForwardRef as ReactComponent };